import type { ReactNode } from "react";
import type { TooltipTriggerButtonProps } from "@design-system/overlay/triggerButtonProps";
import { Picker } from "@design-system/Picker/Picker.lib";

interface ComboboxTriggerButtonProps {
    buttonProps?: TooltipTriggerButtonProps;
    className?: string;
    ariaLabel?: string;
    value: ReactNode;
    placeholder: string;
    hideArrow?: boolean;
}

/**
 * Default button trigger of the split comboboxes: a primary md `Picker.Button`
 * built from the caller's `buttonProps`, whose `tooltip` wraps the button.
 */
export const ComboboxTriggerButton = ({
    buttonProps,
    className,
    ariaLabel,
    value,
    placeholder,
    hideArrow,
}: ComboboxTriggerButtonProps) => {
    const {
        tooltip,
        variant = "primary",
        ...buttonRest
    } = { className, ...buttonProps };

    return (
        <Picker.ButtonTrigger
            render={
                <Picker.Button
                    aria-label={ariaLabel}
                    {...buttonRest}
                    variant={variant}
                    size={buttonRest.size ?? "md"}
                />
            }
            value={value}
            placeholder={placeholder}
            tooltip={tooltip}
            showChevron={hideArrow ? false : undefined}
        />
    );
};
